import { Pipe, PipeTransform } from '@angular/core';
import { Realisation } from 'src/app/classes/realisation';
import { AuthorisationService } from 'src/app/services/auth/authorisation.service';
import { Functionalities } from 'src/app/services/auth/functionalities';
import { Settings } from 'src/app/settings.class';
import { LocalStorage } from 'src/app/storage.class';

@Pipe({
    name: 'OwnHourEditAllowed',
    standalone: false,
})
export class OwnHourEditAllowedPipe implements PipeTransform {
    transform(realisation: Realisation, ...args: unknown[]): unknown {
        // CommonHourCheck = always allowed to edit realistions, untill they are paid
        if (AuthorisationService.hasFunctionality(Functionalities.CommonHourCheck) && !realisation.paid) {
            return true;
        }
        if (
            realisation.approved &&
            (LocalStorage.getUser().hours_checked_by || LocalStorage.getUser().hours_checked_by_role)
        ) {
            return false;
        }
        const now = new Date();
        const enddate = new Date(realisation.enddate);

        const diff = (now.getTime() - enddate.getTime()) / 1000 / 60 / 60;

        return (
            diff < Settings.HOUR_EDIT_ALLOWED_HOURS_EXTENDED &&
            !realisation.approved &&
            realisation.user_id === LocalStorage.getUser().id
        );
    }
}
